import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import $ from 'jquery';


export default class Lightningpopup extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
        open: false,
        title: "",
        sign_type: "",
        manu: "",
        model_list: [],
        manu_list: ["애플","삼성","LG","기타"],
        select_model_list: [],
        select_model: null,
        select_model_idx: 0,
        support1: 0,
        support2: 0,
        last_price: 0,
        priority: "",
        appl_phone_number : "",
        appl_name : ""
    };
  }

  Open()
  {
    this.setState({
      open: true
    });
  }
  Close()
  {
    this.setState({
        open: false
    });
  }

  selectOption(sign_type)
  {
    //console.log(sign_type);
    const self = this;
    this.setState({
      sign_type: sign_type
    });

    $.get('http://mbadmin.nebi.co.kr/api/mobile/flashing?sign_type=' + sign_type,
      {},
      function(data) {
        let jsonData = JSON.parse(data);
        self.setState({
          model_list: jsonData.data
        }, self.signTypeChanged);
    });
  }

  signTypeChanged()
  {

    if( this.state.select_model_idx != 0 )
    {
      this.deviceApplied();
    }
    //this.reCalc();
  }

  manuChanged(event)
  {
    this.setState({
      manu: event.target.value
    }, this.modelFilter);
  }

  deviceChanged(event)
  {
    //console.log(event.target.value);
    this.setState({
      select_model_idx: event.target.value
    },this.deviceApplied);

  }

  deviceApplied(){
    let deviceList = this.state.model_list;

    for(var i = 0 ; i < deviceList.length; i++)
    {
      if( this.state.select_model_idx == deviceList[i].idx)
      {
        this.setState({
          select_model : deviceList[i]
        }, this.reCalc);
        break;
      }
    }
  }


  reCalc()
  {
    let monthPrice = this.state.select_model.fee_price;
    let select_model = this.state.select_model;
    let price1 = select_model.release_price -  select_model.subsidy - select_model.supportA;

    var nSelPriceVat = Math.round( monthPrice * ( 25 / 100 ) );
    var nSelPrice = Math.round( ( monthPrice / 1.1 ) * ( 25 / 100 ) );
    var nMonthDcPricePoint = Math.floor(nSelPrice - nSelPrice);
    var lastPrice = 0;
    var nMonthPriceRemain = (monthPrice / 1.1) % 10;
    if ( nMonthDcPricePoint > 0 && !nMonthPriceRemain )
    {
      lastPrice = nSelPriceVat;
    } else {
      // 기본 선택약정 할인금액의 10의 자리 이하 값
      var nSelPrice100Above = parseInt((nSelPrice / 100));
      var nSelPrice100Below = nSelPrice - (nSelPrice100Above * 100);
      if ( $.inArray(nSelPrice100Below, [0, 5, 50]) >= 0 ) {
        lastPrice = nSelPriceVat;
      } else {
        if ( nSelPrice100Below < 50 )
        {
          lastPrice = (nSelPrice100Above + 0.5) * 100 * 1.1;
        } else {
          lastPrice = (Math.round(Math.round(nSelPrice) / 100)) * 100 * 1.1;
        }
      }
    }
    var select_promise_price = Math.floor(lastPrice);
    let price2 = select_model.release_price - (select_promise_price * 24) - select_model.supportB;

    if( price1 < price2 )
    {
      this.setState({
        priority : "공통지원금",
        support1 : select_model.subsidy,
        support2 : select_model.supportA,
        last_price : price1
      });
    } else {
      this.setState({
        priority : "선택할인",
        support1 : (select_promise_price * 24),
        support2 : select_model.supportB,
        last_price : price2
      });
    }
  }

  modelFilter()
  {
    var select_model_list = [];
    let model_list = this.state.model_list;
    for(var i = 0 ; i < model_list.length ; i++)
    {
      if( model_list[i].manufacturer === this.state.manu )
      {
        select_model_list.push(model_list[i])
      }
    }
    this.setState({
      select_model_list: select_model_list
    });
  }

  onApplPhoneNumberChanged(event)
  {
    this.setState({
      appl_phone_number : event.target.value
    });
  }

  onApplNameChanged(event)
  {
    this.setState({
      appl_name  : event.target.value
    });
  }

  requestPhone()
  {
    let self = this;
    if(self.state.select_model_idx == 0)
    {
      alert('모델을 선택해주세요');
      return;
    }
    let priceDisplay = self.state.select_model.release_price - self.state.support1 - self.state.support2;
    if( priceDisplay < 0)
    {
      priceDisplay = 0;
    }
    $.post('http://mbadmin.nebi.co.kr/api/mobile/sumbitFlashing',{
      device_idx: self.state.select_model_idx,
      support: self.state.support2,
      sign_type: self.state.sign_type,
      discount_type:  (self.state.priority === "공통지원금" ? 0 : 24),
      subsidy: self.state.support1,
      appl_phone_number: self.state.appl_phone_number,
      appl_name: self.state.appl_name ,
      price: priceDisplay
    },function(){
      alert('신청이 접수되었습니다. 확인 후 연락드리겠습니다.');
      self.Close();
    });
  }

  render()
  {
    const self = this;

    let priceDisplay = 0
    if( self.state.select_model )
    {
      priceDisplay = Math.floor( (self.state.select_model.release_price - self.state.support1 - self.state.support2) /10000);
      if( priceDisplay < 0 )
      {
        priceDisplay =0;
      }
    }

    return (
      <Modal open={this.state.open} onClose={()=>{self.Close()}} center>
        <div className="modal-dialog mb0" style={{minWidth:'300px'}}>

          <div className="pt10 pb10">
          <div className="text-center">
            <h4>특가 간편 확인</h4>
          </div>
          <ul className="nav nav-pills nav-justified promise calendar">
            <li className={'border-gray promise1 start fontnor14 '}>
              <a className={'cursorhand' + (self.state.sign_type === 'N' ? " selectOptionPopup" : "")} onClick={()=>{self.selectOption('N')}}>
                <div><b>신규가입</b></div>
                {self.state.sign_type === '' ?
                <div>
                  <img className="maxwidth150_important" src={'img/icon_phone_new.png'} />
                </div> : "" }
              </a>
            </li>
            <li className={'border-gray promise1 start fontnor14 '}>
              <a className={'cursorhand' + (self.state.sign_type === 'M' ? " selectOptionPopup" : "")} onClick={()=>{self.selectOption('M')}}>
              <div><b>번호이동</b></div>
              {self.state.sign_type === '' ?
              <div>
                <img className="maxwidth150_important" src={'img/icon_phone_cha.png'} />
              </div> : "" }
              </a>
            </li>
            <li className={'border-gray promise1 start fontnor14 '}>
              <a className={'cursorhand' + (self.state.sign_type === 'C' ? " selectOptionPopup" : "")} onClick={()=>{self.selectOption('C')}}>
              <div><b>기기변경</b></div>
              {self.state.sign_type === '' ?
              <div>
                <img className="maxwidth150_important" src={'img/icon_phone_gigi.png'} />
              </div> : "" }
              </a>
            </li>
          </ul>

          <div>
          {self.state.sign_type === '' ? "" :
            <div>

              <div className="form-group pt10">
                <div className="row">
                  <div className="col-xs-12 col-md-4 pt6">
                    <label htmlFor="user_name ">제조사</label>
                  </div>
                  <div className="col-xs-12 col-md-8">
                      <select defaultValue={self.state.manu} onChange={self.manuChanged.bind(this)}  className="form-control">
                        <option value="">제조사선택</option>
                        <option value="애플">애플</option>
                        <option value="삼성">삼성</option>
                        <option value="LG" >LG</option>
                        <option value="기타" >기타</option>
                      </select>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="row">
                  <div className="col-xs-12 col-md-4">
                    <label htmlFor="user_name ">모델</label>
                  </div>
                  <div className="col-xs-12 col-md-8">
                    <select onChange={self.deviceChanged.bind(this)} className="form-control">
                      <option>모델 선택</option>
                      {self.state.select_model_list.length != 0 && self.state.select_model_list.map(item=>
                        <option key={item.idx} value={item.idx}>{item.name} - {item.model}</option>
                      )}
                    </select>
                  </div>
                </div>
              </div>
              { (self.state.select_model) ? <div className="form-group mg-b-0">
                  <div className="row pd-l-15 pd-r-15 pd-t-15">
                    <div className="col-md-offset-1 col-md-10 col-xs-12">
                    <table className="table center font14">
                      <tbody>
                      <tr className="border_bottom">
                        <td className="text-center pd0 line18"><b>출고가</b></td>
                        <td className="text-center pd0 line18"><b>{Math.floor(self.state.select_model.release_price/10000)}</b>만원</td>
                      </tr>
                      <tr>
                        <td className="text-center pd0 line18"><b>{self.state.priority}</b></td>
                        <td className="text-center  pd0 line18"><b>{Math.floor(self.state.support1/10000)}</b>만원</td>
                      </tr>
                      <tr className="border_bottom">
                        <td className="text-center pd0 line18"><b>복지지원금</b></td>
                        <td className="text-center  pd0 line18"><b>{Math.floor(self.state.support2/10000)}</b>만원</td>
                      </tr>
                      <tr>
                        <td className="text-center line18"><b>{self.state.select_model.name}</b></td>
                        <td className="text-center font20 line18"><span className="spe_price"><b>
                        {priceDisplay}
                        </b></span>만원</td>
                      </tr>
                      </tbody>
                    </table>
                    </div>
                  </div>
                </div>: "" }

              <div className="form-group">
                <div className="row">
                  <div className="col-xs-12 col-md-4">
                    <label htmlFor="user_name ">상담 신청인 성함</label>
                  </div>
                  <div className="col-xs-12 col-md-8">
                    <input type="text" id="appl_name" onChange={self.onApplNameChanged.bind(this)}  className="form-control" />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <div className="row">
                  <div className="col-xs-12 col-md-4">
                    <label htmlFor="user_name ">상담 신청인 연락처</label>
                  </div>
                  <div className="col-xs-12 col-md-8">
                    <input type="text" id="appl_phone_number" onChange={self.onApplPhoneNumberChanged.bind(this)}  className="form-control" />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <div className="row mg0">
                <a onClick={()=>{self.requestPhone()}} className={'col-xs-12 btn btn-baru' + ( self.state.appl_name != "" && self.state.appl_phone_number != "" ?  '' : ' disabled')  }>신청하기</a>
                </div>
              </div>

            </div>
            }
          </div>

          </div>
        </div>
      </Modal>
    )
  }
}

